import { render, staticRenderFns } from "./DriverProfile.vue?vue&type=template&id=92881b3a&scoped=true"
import script from "./DriverProfile.vue?vue&type=script&lang=ts"
export * from "./DriverProfile.vue?vue&type=script&lang=ts"
import style0 from "./DriverProfile.vue?vue&type=style&index=0&id=92881b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92881b3a",
  null
  
)

export default component.exports